"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MimeTypes = void 0;
const MimeDB_1 = require("./resources/MimeDB");
class MimeTypes {
    constructor() {
        this.extensions = {};
        this.types = {};
        this.populateMaps();
    }
    extension(type) {
        if (!type) {
            return false;
        }
        const match = MimeTypes.EXTRACT_TYPE_REGEXP.exec(type);
        let extensions = [];
        if (match && match[1]) {
            extensions = match && this.extensions[match[1].toLowerCase()];
            if (!extensions || !extensions.length) {
                return false;
            }
        }
        return extensions[0];
    }
    lookup(path) {
        if (!path) {
            return false;
        }
        let extension = "";
        const matches = path.match(/.([a-z0-9]*)$/i);
        if (matches && matches.length === 2) {
            extension = matches[1].toLocaleLowerCase();
        }
        if (!extension) {
            return false;
        }
        return this.types[extension] || false;
    }
    populateMaps() {
        const self = this;
        Object.keys(MimeDB_1.MimeDB).forEach((type) => {
            const extensions = MimeDB_1.MimeDB[type];
            self.extensions[type] = extensions;
            for (const ext of extensions) {
                self.types[ext] = type;
            }
        });
    }
}
exports.MimeTypes = MimeTypes;
MimeTypes.EXTRACT_TYPE_REGEXP = /^\s*([^;\s]*)(?:;|\s|$)/;
